import * as t from 'io-ts';
import { UUID } from 'io-ts-types/UUID';

import { Type } from './Type';

export const RecordRetentionEditedC = t.type({
    type: t.literal(Type.RETENTION_EDIT),
    ids: t.array(UUID),
    all: t.boolean,
});

export type RecordRetentionEdited = t.TypeOf<typeof RecordRetentionEditedC>;
